var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSachwort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Legende_Sachwort__Icn/40px/Legende/Sachwort",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Legende_Sachwort__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Legende_Sachwort__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19,10 C23.9705627,10 28,14.0294373 28,19 C28,21.124779 27.2636898,23.0775836 26.0323074,24.6171757 L30.2426407,28.8284271 L28.8284271,30.2426407 L24.6171757,26.0323074 C23.0775836,27.2636898 21.124779,28 19,28 C14.0294373,28 10,23.9705627 10,19 C10,14.0294373 14.0294373,10 19,10 Z M19,12 C15.1340068,12 12,15.1340068 12,19 C12,22.8659932 15.1340068,26 19,26 C22.8659932,26 26,22.8659932 26,19 C26,15.1340068 22.8659932,12 19,12 Z M20.0102539,13.710083 L23.7363281,23.0157471 L21.6923828,23.0157471 L20.8798828,20.9019775 L17.1601562,20.9019775 L16.3920898,23.0157471 L14.3989258,23.0157471 L18.0234375,13.710083 L20.0102539,13.710083 Z M18.9946289,15.8809814 L17.737793,19.3341064 L20.2768555,19.3341064 L18.9946289,15.8809814 Z",
    id: ".._.._src_svg_Icn_40px_Legende_Sachwort__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSachwort);
export default __webpack_public_path__ + "static/media/Sachwort.8ee5a01bc3552f559eec134d6e366593.svg";
export { ForwardRef as ReactComponent };